module.exports = __webpack_public_path__ + "img/about-us-zs-4.3812e3e3.png";